import { roundsInfoStore } from '../../store';
import { createImgDom, getGameCanvasStandards, shrinkTextFontByArea } from '../../helpers/gameCanvasHelper';
import { betTypes } from '../../enums';
import winBlockBackgroundPng from '../../assets/images/game/wining-block.png';
import coinsPng from '../../assets/images/game/coins.png';
import { gameResultStore, parseNumberByPrecision, userInfoStore, userSettingsStore } from '@pascal/pascal-core';
import { soundService, soundTypes } from '../../services';
import { rangeBetBlockSize } from '../../constants/canvasConfig';

const winBlockBackgroundImg = createImgDom(winBlockBackgroundPng);
const coinsImg = createImgDom(coinsPng);

let isStartedInterpolation = false;
let ALPHA = 0;

const isHaveWiningBets = () => {
  const { winingBets } = roundsInfoStore;
  return winingBets[betTypes.over] || winingBets[betTypes.under] || winingBets[betTypes.range];
};

const winingBetBlocksSizeInterpolation = () => {
  isStartedInterpolation = true;

  const drawWiningBetBlocks = () => {
    if (ALPHA >= 1) {
      return;
    }

    ALPHA = Math.min(1, ALPHA + 0.05);

    requestAnimationFrame(drawWiningBetBlocks);
  };

  drawWiningBetBlocks();
};

const winingBetBlock = (x, y, w, h, odd, amount) => {
  const { ctx } = getGameCanvasStandards();
  ctx.drawImage(winBlockBackgroundImg, x, y, w, h);
  const winAmount = parseNumberByPrecision(odd, amount);
  const amountText = winAmount + userInfoStore.currencySymbolOrCode;

  ctx.fillStyle = '#fdc11e';
  shrinkTextFontByArea(amountText, w, 18, 'ZektonRg-Regular', 900);
  ctx.fillText(amountText, x + w / 2 - ctx.measureText(amountText).width / 2, y + h * 0.6);

  const coins = {
    w: w * 1.5 + ALPHA * w * 0.5,
    h: h * 1.5 + ALPHA * h * 0.5,
    x: x - w * 0.25 - ALPHA * w * 0.25,
    y: y - h * 0.25 - ALPHA * h * 0.25,
  };

  ctx.drawImage(coinsImg, coins.x, coins.y, coins.w, coins.h);
};

export const drawWiningAnimation = () => {
  const { gameResults } = gameResultStore;
  const lustResult = gameResults[6] ? gameResults[6].roundData.resultPoint : 0;
  const { canvas, ctx } = getGameCanvasStandards();
  const { presentPoint, winingBets, concentrationDiff } = roundsInfoStore;
  if (!isHaveWiningBets()) {
    isStartedInterpolation = false;
    ALPHA = 0;
  }

  if (isHaveWiningBets()) {
    ctx.fillStyle = 'rgb(0,0,0,0.5)';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    if (!isStartedInterpolation) {
      const { isSoundOn } = userSettingsStore;
      winingBetBlocksSizeInterpolation();
      if(isSoundOn) {
        soundService.playWin();
        soundService.play(soundTypes.wining);
      }
    }
  }

  if (winingBets[betTypes.range]) {
    const y = canvas.height - (winingBets[betTypes.range].point * 10 - concentrationDiff) - rangeBetBlockSize.height;
    const x = presentPoint.x;
    const w = 100,
      h = 50;
    const { odd, amount } = winingBets[betTypes.range];
    winingBetBlock(x, y, w, h, odd, amount);
  }

  if (winingBets[betTypes.over]) {
    const x = presentPoint.x - 165;
    const y = canvas.height - ((lustResult + 12) * 10 - concentrationDiff);
    const w = 150,
      h = 75;
    const { odd, amount } = winingBets[betTypes.over];
    winingBetBlock(x, y, w, h, odd, amount);
  }

  if (winingBets[betTypes.under]) {
    const x = presentPoint.x - 165;
    const y = canvas.height - ((lustResult - 5) * 10 - concentrationDiff);
    const w = 150,
      h = 75;
    const { odd, amount } = winingBets[betTypes.under];
    winingBetBlock(x, y, w, h, odd, amount);
  }
};


